import { render, staticRenderFns } from "./academicInfo.vue?vue&type=template&id=662fe5b5&scoped=true"
import script from "./academicInfo.vue?vue&type=script&lang=js"
export * from "./academicInfo.vue?vue&type=script&lang=js"
import style0 from "./academicInfo.vue?vue&type=style&index=0&id=662fe5b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662fe5b5",
  null
  
)

export default component.exports